import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import AdminTitle from '../../../common/AdminTitle/AdminTitle';
import { useDeleteGalleryMutation, useListAllGalleryQuery } from '../../../api/gallery.api';
import { toast } from 'react-toastify';
import './Gallery.css'
import GalleryImage from './GalleryImage';
import LoadingComponent from '../../../common/Loading/Loading.component';
import { Pagination } from 'flowbite-react';

const GalleryList = () => {
    const [page, setPage] = useState(1);
    const [limit] = useState(20); 

    const {data,error,isLoading} = useListAllGalleryQuery({page, limit,})
    const [deletePhoto] = useDeleteGalleryMutation()
    
    const galleries = data?.result?.allImages || [];
    const handlePageChange = (newPage) => {
        setPage(newPage);
      };


    const deleteData = async(rowId)=>{
        try{
            await deletePhoto({imageUrl: rowId }).unwrap()
            toast.success("Image deleted")
        }catch(exception){
            toast.error("error while deleting image")
        }
    }
    if(isLoading){
        return <LoadingComponent/>
    }
  return (
    <div className="admin_margin_box">
        <div className="admin_titles">
            <AdminTitle label1="Gallery List" />
            <div className="Dashboard_title">
                <h1>Gallery List</h1>
                <div>
                    <Link to="/dashboard/gallery_add">
                        <button className="edit_btn">Add gallery</button>
                    </Link>
                </div>
            </div>
        </div>
        <div className="gallery_grid">
             {galleries.map((item, index) => (
               <GalleryImage key={index} link={item} image={item} deleteAction={deleteData} rowId={item}/>
            ))}
        </div>
        <div className='flex overflow-x-auto sm:justify-center'>
            {data?.meta && data?.meta.total > 0 && (
            <div className='flex overflow-x-auto sm:justify-center'>
                <Pagination
                currentPage={data?.meta.currentPage}
                totalPages={Math.ceil(data?.meta.total / limit)}
                onPageChange={handlePageChange}
                />
            </div>
            )}
        </div>
        
    </div>
  )
}

export default GalleryList